/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Settings_ScheduledInputs */

const en_error_allocation_settings_scheduled = /** @type {(inputs: Error_Allocation_Settings_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A change of the allocation setup already waits for its date: withdraw it first.`)
};

/**
* | output |
* | --- |
* | "A change of the allocation setup already waits for its date: withdraw it first." |
*
* @param {Error_Allocation_Settings_ScheduledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_settings_scheduled = /** @type {((inputs?: Error_Allocation_Settings_ScheduledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Settings_ScheduledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_settings_scheduled(inputs)
});